import React, {Component} from 'react';

import Fuse from 'fuse.js';

import {getLocations, getLocation} from '../../../sources/Locations';
import {observer} from 'mobx-react';
import {withRouter} from 'react-router-dom';
import Location from './Location';
import ListItem from '../../shared/ListItem';

import TrayContainerWithHeader from '../../shared/TrayContainerWithHeader';
import withLocationPersistence from '../../hoc/WithLocationPersistence';
import {toJS} from "mobx";
import bbox from "@turf/bbox";

import roomNumber from '../../../assets/images/room-number.jpg';

@withRouter
@withLocationPersistence
@observer
class Where extends Component {
  constructor(props) {
    super(props);

    this.state = {filter: '', searchStarted: false};
    this.fuseSearch = new Fuse(
      this.props.mapStore.allFloorsData.filter((item) => {
        return item.type === "gallery";
      }),
      {
        keys: ["title"]
      }
    );
    // this.updateStateAndLocationAttribute = this.updateStateAndLocationAttribute.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.mapStore.currentItem = this.props.mapStore.allFloorsData.find((item) => {
        return (item.id === this.props.match.params.id)
      });
      if (this.props.whereAmI === true) {
        this.props.mapStore.userLocationId = this.props.mapStore.currentItem.id;
        this.props.mapStore.trayContainerClass = 'is-flexible';
      } else {
        this.props.mapStore.foundLocationId = this.props.mapStore.currentItem.id;
        this.props.mapStore.trayContainerClass = 'is-flexible';
      }

      if (parseInt(this.props.mapStore.floor) !== parseInt(this.props.mapStore.currentItem.level)) {
        this.props.mapStore.floor = parseInt(this.props.mapStore.currentItem.level);
      }

      if (this.props.mapStore.currentItem) {
        const feature = toJS(this.props.mapStore.geoJsonFeatures.find((feature) => this.props.mapStore.currentItem.id === feature.properties.id));
        const bounds = bbox(feature);
        this.props.mapStore.bounds = [[bounds[1], bounds[0]], [bounds[3], bounds[2]]]
      }

    }
  }

  trackSearchAndUpdateLocation(event) {
    let eventName;
    if (this.props.whereAmI === true) {
      eventName = 'mapWhereAmIStart';
    } else {
      eventName = 'mapFindRoomStart';
    }

    if (!this.state.searchStarted) {
      window.dataLayer.push({
        'event': eventName
      });
      this.setState({searchStarted: true})
    }
    this.updateStateAndLocationAttribute(event);
  }

  trackRoomClick(event) {
    let eventName;
    if (this.props.whereAmI === true) {
      eventName = 'mapWhereAmIClick'
    } else {
      eventName = 'mapFindRoomClick'
    }

    window.dataLayer.push({
      'event': eventName,
      'room': event.currentTarget.getAttribute('data-name')
    });


  }

  getChildComponent() {
    let child;

    let path;
    if (this.props.whereAmI === true) {
      path = '/where-am-i';
    } else {
      path = '/find/room'
    }

    if (this.props.match.params.id && this.props.mapStore.currentItem) {
      child =
        <TrayContainerWithHeader title={this.props.title} trayClass="room-detail" currentItem={this.props.mapStore.currentItem}
                                 mapStore={this.props.mapStore} params={{path: path, ...this.props.match.params}}>
          <Location {...this.props.mapStore.currentItem} />
        </TrayContainerWithHeader>
    } else if (this.props.match.params.id && !this.props.mapStore.currentItem) {
      // loading state
      return <React.Fragment></React.Fragment>
    } else {
      let items = [];

      if( this.state.filter.length ) {
        items = this.props.mapStore.allFloorsData.filter((item) => {
          return item.type === "gallery";
        });

        items = this.fuseSearch.search(this.state.filter);
      }

      let results = (<div className="results">
        <div className="scroll-pane">
          {items.map((data, i) => {
            return <ListItem key={`${this.props.match.url}-list-id-${i}`} path={`${path}/${data.id}`}
                             name={data.title || ""} image={data.image ? data.image[0] : ""} itemType="room" data={{name: data.title || ''}} onClick={this.trackRoomClick.bind(this)}/>
          })}
        </div>
      </div>);

      child = (
        <TrayContainerWithHeader title={this.props.title} trayClass="room-search" params={{path: path, ...this.props.match.params}}>
          <div className="form-group">
            <input type="text" name="filter" autoComplete="off" value={this.state.filter} onChange={this.trackSearchAndUpdateLocation.bind(this)} placeholder="Type a room number or name…"/>
          </div>

          { this.state.filter.length === 0 &&
            <div className="note">
              <div className="image"><img src={roomNumber} alt=""/></div>
              <div className="text-content">
                <p>Tip: Look for a numbered sign above or near the door to the room, or ask a member of staff.</p>
              </div>
            </div>
          }

          {results}
        </TrayContainerWithHeader>
      )
    }

    return (
      <div>
        {child}
      </div>
    )
  }

  render() {
    return this.getChildComponent();
  }
}

export default Where;
